import React from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { getStripe } from '../services/api'

function withStripeElementsHoC (Component) {
  const withStripeElements = props => (
    <Elements stripe={getStripe()}>
      <Component {...props} />
    </Elements>
  )

  return withStripeElements
}

export default withStripeElementsHoC
